import axios from 'axios';
import { Message } from 'element-ui';
import store from '../store';
import router from '../router';
// 创建axios实例
const service = axios.create({
  //baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000                  // 请求超时时间
});
// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  return config;
}, error => {
  // Do something with request error
  //console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    //相当于给所有请求统一做了错误处理
    //下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
    //如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
    const status = response.status
    if( status === 200 ){
      const url = response.config && response.config.url
      var data = response.data
      const ret = data.ret ? data.ret : 0
      return data
    } else {
      return response
    }
  },
  error => {
    const response = error.response
    console.log(error)
    if(response){
      const status = response.status
      let data = response.data
      const ret = data.ret
      if(status===400){ //param error

      }else if( status===401 ){
        if( ret===1 ){
          location.href="/login"
          return false
        }else if( ret===2 ){
          data.msg = "您不是城市合伙人或者分销商"
        }else if( ret===3 ){
          router.push({name:"Account"})
        }else if( ret===6 ){
          location.href="/login"
          return false
        }
      }else if( status===500 ){

      }

      Message({
        message: data.msg,
        type: 'error',
      })
    }
    return Promise.reject(error);
  }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js